<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="replacementBills">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editPage.open(0)">新建</el-button>
        <el-button type="primary" :loading="exportLoading" @click="exportExcel()">导出</el-button>
      </div>
      <template slot="adSearch">
        <vm-search label="登记日期">
          <div class="block">
            <el-date-picker
                v-model="filter.beginCreateTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.endCreateTime"
                value-format="yyyy-MM-dd 23:59:59"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
        <vm-search label="单号">
          <el-input v-model.trim="filter.billNo" clearable/>
        </vm-search>
        <vm-search label="出厂编号">
          <el-input v-model.trim="filter.salesOrderNo" clearable/>
        </vm-search>
        <vm-search label="客户名称">
          <el-input v-model.trim="filter.customerName" clearable/>
        </vm-search>
        <vm-search label="登记人">
          <el-input v-model.trim="filter.creatorName" clearable/>
        </vm-search>
        <vm-search label="现场联系人">
          <el-input v-model.trim="filter.contact" clearable/>
        </vm-search>
        <vm-search label="现场联系方式">
          <el-input v-model.trim="filter.mobile" clearable/>
        </vm-search>
        <vm-search label="销售员">
          <el-input v-model.trim="filter.salesName" clearable/>
        </vm-search>
        <vm-search label="客户单号">
          <el-input v-model.trim="filter.customerBillNo" clearable/>
        </vm-search>
        <vm-search label="现场名称">
          <el-input v-model.trim="filter.siteName" clearable/>
        </vm-search>
        <vm-search label="物料号">
          <el-input v-model.trim="filter.materialNo" clearable/>
        </vm-search>
        <vm-search label="物料名称">
          <el-input v-model.trim="filter.materialDesc" clearable/>
        </vm-search>
        <vm-search label="发运人">
          <el-input v-model.trim="filter.deliveryPerson" clearable/>
        </vm-search>
        <vm-search label="收件人">
          <el-input v-model.trim="filter.consignee" clearable/>
        </vm-search>
        <vm-search label="流程状态">
          <el-select v-model.trim="filter.flowStatus" clearable placeholder="请选择流程状态">
            <el-option label="草稿" :value="10"/>
            <el-option label="待售后审核" :value="20"/>
            <el-option label="待售后复审" :value="30"/>
            <el-option label="待发货" :value="40"/>
            <el-option label="已完成" :value="50"/>
          </el-select>
        </vm-search>
        <vm-search label="发运类型">
          <el-select v-model.trim="filter.shipmentType" clearable placeholder="请选择发运类型">
            <el-option label="电机整机" :value="1"/>
            <el-option label="电机板卡" :value="2"/>
            <el-option label="电机整机/板卡" :value="3"/>
            <el-option label="电气产品" :value="4"/>
            <el-option label="外购件" :value="5"/>
            <el-option label="自制品" :value="6"/>
            <el-option label="维修件" :value="7"/>
          </el-select>
        </vm-search>
        <vm-search label="序列号">
          <el-input v-model.trim="filter.mainPartsSerialNo" clearable/>
        </vm-search>
        <vm-search label="项目号">
          <el-input v-model.trim="filter.faultSerialNO" clearable/>
        </vm-search>
      </template>
      <el-table-column fixed="left" type="expand">
        <template slot-scope="props">
          <el-table :data="props.row.details" style="width: 100%;margin: 0 auto">
            <el-table-column align="center" label="SAP物料号" prop="materialNo"/>
            <el-table-column align="center" label="规格/型号/名称" prop="materialDesc"/>
            <el-table-column align="center" label="数量" prop="quantity" width="80"/>
            <el-table-column align="center" label="单位" prop="unit" width="80"/>
            <el-table-column align="center" label="发运日期" prop="deliveryDate"/>
            <el-table-column align="center" label="发运单号" prop="deliveryBillNo"/>
            <el-table-column align="center" label="发运人" prop="deliveryPerson"/>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column
          fixed="left"
          prop="billNo"
          width="140"
          align="center"
          label="售后单号">
        <template slot-scope="scope">
          <span style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.billNo}}</span>
          <el-button
              v-clipboard="scope.row.billNo"
              v-clipboard:success="clipboardSuccessHandler"
              v-clipboard:error="clipboardErrorHandler"
              round
              icon="el-icon-chat-line-square"/>
        </template>
      </el-table-column>
      <el-table-column prop="submitTime" width="180" align="center" label="提交时间"/>
      <el-table-column
          prop="salesOrderNo"
          width="120"
          align="center"
          label="出厂编号"/>
      <el-table-column prop="customerBillNo" align="center" label="客户单号"/>
      <el-table-column prop="customerName" width="200" align="center" label="客户名称"/>
      <el-table-column prop="deliveryAddress" width="280" align="center" label="服务地点"/>
      <el-table-column prop="nodeDesc" width="140" align="center" label="当前节点">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 100 || scope.row.status === 90">已完成</span>
          <span v-else>{{scope.row.nodeDesc}}</span>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          width="160"
          align="center">
        <template slot-scope="scope">
          <el-button v-if="(scope.row.status===10 && scope.row.creatorId === currentId) || editAuth" plain type="primary" @click="$refs.editPage.open(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.nodeDesc==='售后审核' && scope.row.creatorId === currentId" plain type="primary" @click="$refs.editPage.open(scope.row)">权限编辑</el-button>
          <el-button v-if="exportGYSAuth" plain type="primary" @click="$refs.exportPage.open(scope.row)">导出-供应商</el-button>
          <el-button v-if="(scope.row.status===10 && scope.row.creatorId === currentId) ||editAuth" plain type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <replacement-edit ref="editPage" @save-success="getList(1)"/>
    <replacement-export-edit ref="exportPage"/>
  </div>
</template>



<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import ReplacementEdit from "@/views/afterSalesManagement/Replacement/ReplacementEdit";
  import ReplacementExportEdit from "@/views/afterSalesManagement/Replacement/ReplacementExportEdit";
  import loginUtil from "@/util/loginUtil";
  export default {
    name: "ReplacementList",
    components: {ReplacementExportEdit, ReplacementEdit, VmTable,VmSearch},
    data() {
      return {
        idList: "",
        currentId: loginUtil.getUserId(),
        editAuth: this.$auth(892),
        exportGYSAuth: this.$auth(893),
        creatorAuth: this.$auth(894),
        exportLoading: false,
        filter: {
          billNo: "",
          factoryNo: "",
          customerName: "",
          creatorName: "",
          contact: "",
          mobile: "",
          status: "",
          customerBillNo: "",
          siteName: "",
          materialNo: "",
          materialDesc: "",
          deliveryPerson: "",
          consignee: "",
          flowStatus: "",
          shipmentType: "",
          mainPartsSerialNo: "",
          faultSerialNO: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      clipboardSuccessHandler(e) {
        this.$message.success("复制单号成功");
      },
      clipboardErrorHandler(e) {
        this.$message.error("复制单号失败");
      },
      submit(pkid) {
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.$http.get("basic", "replacementBills/status/" + pkid).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          });
        });
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "replacementBills/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      copyBillNo(billNo) {
        this.$copyText(billNo).then(function(e) {
          alert("success");
          console.log(e);
        }, function(e) {
          alert("Can not copy");
          console.log(e);
        });
      },
      goto(row) {
        this.$router.push({
          path: "/Replacement",
          query: {
            billType: 13,
            billId: row.pkid,
            $tabName: row.billNo,
          },
        });
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","replacementBills",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
